import {Component, OnInit, ViewChild} from '@angular/core';
import {MatDialog} from '@angular/material/dialog';
import {MatPaginator} from '@angular/material/paginator';
import {MatSort} from '@angular/material/sort';
import {MatTableDataSource} from '@angular/material/table';
import {Router} from '@angular/router';
import {CommonService} from '../../../services/common.service';
import {ExcelService} from '../../../services/excel.service';
import {ReportService} from '../../../services/report.service';
import {ToastMessagesService} from '../../../services/toast-messages.service';
import {ReportReminderDialogComponent} from '../../shared/report-reminder-dialog/report-reminder-dialog.component';
import {
  CustomFormRemindersDialogComponent
} from './custom-form-reminders-dialog/custom-form-reminders-dialog.component';

@Component({
  selector: 'app-custom-form-reports',
  templateUrl: './custom-form-reports.component.html',
  styleUrls: ['./custom-form-reports.component.scss']
})
export class CustomFormReportsComponent implements OnInit {
  isLoading: boolean;
  pendingReminderRequest: boolean;
  forms: any[] = [];
  originalForms: any[] = [];
  completed: number;
  finalForms: MatTableDataSource<any> = new MatTableDataSource<any>([]);
  displayColumns = ['title', 'published_at', 'completed', 'pending', 'reminder', 'actions'];
  tableHeight: any;
  @ViewChild(MatPaginator, {static: true}) paginator: MatPaginator;
  @ViewChild(MatSort, {static: true}) sort: MatSort;


  constructor(private reportService: ReportService,
              public excelService: ExcelService,
              public router: Router,
              public dialog: MatDialog,
              private commonService: CommonService,
              public toastMessagesService: ToastMessagesService) {
    this.isLoading = true;
    this.completed = 0;
    this.tableHeight = window.innerHeight - 470;
    this.pendingReminderRequest = false;
  }

  async ngOnInit() {
    this.commonService.setPaginatorTexts(this.paginator);
    await this.initReports();
    this.finalForms.paginator = this.paginator;
    this.finalForms.sort = this.sort;
  }

  async initReports() {
    try {
      const startTime = performance.now();

      this.pendingReminderRequest = true;
      this.isLoading = true;
      console.log('[Tab1 - Δηλώσεις χρηστών] Fetching custom forms report...');
      this.originalForms = await this.reportService.getCustomFormsReport();
      console.log('[Tab1 - Δηλώσεις χρηστών] Response:', this.originalForms);
      console.log('[Tab1 - Δηλώσεις χρηστών] Total forms count:', this.originalForms?.length || 0);
      for (const form of this.originalForms) {
        // if (this.forms.findIndex(an => an.form_unique_id === form.form_unique_id) === -1) {
          form.p_date = Date.parse(form.published_datetime);
          form.reminder_sent = '';
          form.reminder_date = null;
          this.forms.push(form);
        // }
      }
      this.forms = this.forms.sort((a, b) => b.p_date - a.p_date);
      this.finalForms = new MatTableDataSource<any>(this.forms);

      this.isLoading = false;

      const promises = [];
      this.finalForms.data.forEach(form => promises.push(this.commonService.getList(`reports/reminder-date?uniqueId=${form.form_unique_id}`)));
      const results = await Promise.all(promises);
      results.forEach((request, index) => {
        if (request.object.action_date) {
          this.finalForms.data[index].reminder_date = request.object.action_date;
          this.finalForms.data[index].reminder_sent = request.object.reminder_sent;
        } else {
          this.finalForms.data[index].reminder_sent = '-';
        }
      });

      this.pendingReminderRequest = false;

      const endTime = performance.now();

      console.log(`Call to doSomething took ${endTime - startTime} milliseconds`);

    } catch (e) {
      this.toastMessagesService.toastErrorMessage(e.message);
    } finally {
      this.isLoading = false;
    }
  }

  getSeconds = (end, start) => {
    return `${(end.getTime() - start.getTime()) / 1000} seconds`;
  }

  notifyUsers(reportAffirmation: any) {

  }

  navigateToDetails(reportAffirmation: any) {

  }

  calculateOpened(row) {
    const completed = row.completed;
    const total = row.total;

    const result = (completed / total) * 100;
    const percentage = Math.round(result);

    if (percentage === 0) {
      return `(${percentage}%)`;
    } else {
      return `${completed}/${total} (${percentage}%)`;
    }
  }

  calculateOpenedOld(formUniqueId: any) {
    const announcements = this.originalForms.filter(announcement => announcement.form_unique_id === formUniqueId);
    const totalSent = announcements.length;
    const completed = announcements.filter(form => form.status === 1).length;
    this.completed = completed;
    const result = (completed / totalSent) * 100;
    const percentage = Math.round(result);

    if (percentage === 0) {
      return `(${percentage}%)`;
    } else {
      return `${completed}/${totalSent} (${percentage}%)`;
    }
  }

  calculatePending(row) {
    const pending = row.pending;
    const total = row.total;

    const result = (pending / total) * 100;
    const percentage = Math.round(result);

    if (percentage === 0) {
      return `(${percentage}%)`;
    } else {
      return `${pending}/${total} (${percentage}%)`;
    }
  }
  calculatePendingOld(formUniqueId: any) {
    const announcements = this.originalForms.filter(announcement => announcement.form_unique_id === formUniqueId);
    const totalSent = announcements.length;
    const notOpened = announcements.filter(form => form.status === 0).length;
    const result = (notOpened / totalSent) * 100;
    const percentage = Math.round(result);

    if (percentage === 0) {
      return `(${percentage}%)`;
    } else {
      return `${notOpened}/${totalSent} (${percentage}%)`;
    }
  }

  async exportToExcel(reportAnnouncement: any) {
    const uniqueFormId = reportAnnouncement.form_unique_id;

    try {
      const data = await this.reportService.getDataToExport(uniqueFormId);

      const columns = this.commonService.formatColumns(data[0]);
      const resultData = [];
      for (const d of data) {
        resultData.push(this.commonService.formatData(d));
      }
      this.excelService.exportAsCustomExcelFile(resultData, reportAnnouncement.title, columns);

    } catch (e) {
      this.toastMessagesService.toastErrorMessage(e.message);
    }
  }

  async showCompleted(form) {
    await this.router.navigate(['home/completed-forms-details'], {queryParams: {formUniqueId: form.form_unique_id}});
  }

  async sendNotification(reportAnnouncement: any) {
    // console.log(reportAnnouncement);
    const uniqueId = reportAnnouncement.form_unique_id;
    try {
      const result = await this.reportService.getFormReportUsers(uniqueId);
      console.log('[sendNotification] Raw result from API:', result);
      console.log('[sendNotification] Total records:', result?.length);
      const completed = result.filter(report => report.status === 1);
      const pending = result.filter(report => report.status === 0);
      console.log('[sendNotification] Completed count:', completed.length, 'Pending count:', pending.length);
      if (pending.length > 0) {
        console.log('[sendNotification] Sample pending record:', pending[0]);
        console.log('[sendNotification] Pending notificationTo:', pending[0]?.notificationTo);
      }
      const emails = {completed, pending};
      this.dialog.open(ReportReminderDialogComponent, {
        height: '100vh',
        // panelClass: 'full-screen-modal',
        data: {
          mode: 0,
          uniqueId,
          emails
        }
      });
    } catch (e) {
      this.toastMessagesService.toastErrorMessage('Δεν μπορέσαμε να φέρουμε τους ζητούμενους χρήστες');
    }
  }

  showRemindersInfo(reportAnnouncement: any) {
    this.dialog.open(CustomFormRemindersDialogComponent, {
      data: {
        uniqueId: reportAnnouncement.form_unique_id,
        title: reportAnnouncement.title,
        mode: 1
      }
    });
  }
}
